export default "__VITE_PUBLIC_ASSET__a8899de7__"